import { motion } from "framer-motion";
import { Upload, Eye, Target } from "lucide-react";
import { useLanguage } from "@/lib/LanguageContext";

const HowItWorks = () => {
  const { t } = useLanguage();

  const steps = [
    { icon: Upload, title: t("howItWorks.step1.title"), desc: t("howItWorks.step1.desc"), delay: 0.1 },
    { icon: Eye, title: t("howItWorks.step2.title"), desc: t("howItWorks.step2.desc"), delay: 0.2 },
    { icon: Target, title: t("howItWorks.step3.title"), desc: t("howItWorks.step3.desc"), delay: 0.3 },
  ];

  return (
    <section className="bg-white/[0.02] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4"
            style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.03em' }}
          >
            {t("howItWorks.title")}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map(({ icon: Icon, title, desc, delay }, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay }}
              className="text-center"
            >
              <div className="w-16 h-16 rounded-2xl bg-yellow-400/10 flex items-center justify-center mx-auto mb-6 relative">
                <Icon className="w-8 h-8 text-yellow-400" />
                <span className="absolute -top-2 -right-2 w-7 h-7 bg-yellow-400 rounded-full flex items-center justify-center text-black font-bold text-sm">
                  {index + 1}
                </span>
              </div>
              <h3 className="font-bold text-xl text-white mb-2">{title}</h3>
              <p className="text-white/50">{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
